module.exports=function(scope){ return `var https = require("https");
var data = JSON.stringify({
  "faceMap": INSERT_FACEMAP_DATA_AS_BASE64_HERE,
  "auditTrailImage": INSERT_AUDIT_TRAIL_IMAGE_HERE,
  "lowQualityAuditTrailImage": INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_HERE
})

callFaceTecAPI(data, "/estimate-age", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(data, path, callback){
  var options = {
    hostname: "your.internal.zoomserver.instance.url",
    port: 443,
    path: path,
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-User-Agent": INSERT_X_USER_AGENT_VALUE_HERE
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj.data)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.write(data)
  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/nodejs/estimate-age.js.tpl